import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Phone, Sparkles } from "lucide-react";

const STATUS_COLOR = { new: "#00f0ff", contacted: "#ffb454", replied: "#a78bfa", won: "#36f08a", lost: "#f0506e" };

export default function LeadMap({ leads, onEmail }) {
  const pts = leads.filter((l) => typeof l.lat === "number" && typeof l.lng === "number");
  const center = pts.length
    ? [pts.reduce((a, l) => a + l.lat, 0) / pts.length, pts.reduce((a, l) => a + l.lng, 0) / pts.length]
    : [39.5, -98.35];
  return (
    <div className="rounded-2xl overflow-hidden border border-white/10 h-[62vh]" data-testid="lead-map">
      {pts.length === 0 ? (
        <div className="h-full grid place-items-center text-zinc-500 text-sm bg-[#0b0e14]">No mapped leads yet — run a search to plot a territory.</div>
      ) : (
        <MapContainer center={center} zoom={pts.length > 1 ? 11 : 13} scrollWheelZoom style={{ height: "100%", width: "100%", background: "#0b0e14" }}>
          <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {pts.map((l) => (
            <CircleMarker key={l.id} center={[l.lat, l.lng]} radius={9}
              pathOptions={{ color: "#05070b", fillColor: STATUS_COLOR[l.status || "new"], fillOpacity: 0.95, weight: 2 }}>
              <Popup>
                <div style={{ minWidth: 180 }}>
                  <div style={{ fontWeight: 700, marginBottom: 2 }}>{l.name}</div>
                  <div style={{ fontSize: 12, color: "#555" }}>{l.address}</div>
                  <div style={{ fontSize: 11, textTransform: "uppercase", color: STATUS_COLOR[l.status || "new"], fontWeight: 700, margin: "4px 0" }}>{l.status || "new"}</div>
                  <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
                    {l.phone && <a href={`tel:${l.phone}`} style={{ display: "flex", alignItems: "center", gap: 3, fontSize: 12, color: "#0b7" }}><Phone size={12} /> Call</a>}
                    {l.email && <button onClick={() => onEmail(l)} style={{ display: "flex", alignItems: "center", gap: 3, fontSize: 12, color: "#06c", background: "none", border: "none", cursor: "pointer", padding: 0 }}><Sparkles size={12} /> Email</button>}
                  </div>
                </div>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      )}
    </div>
  );
}
